// Çok-sekme oturum senkronizasyonu (cross-tab session sync).
//
// Amaç: Aynı tarayıcıda bir sekmede çıkış yapılınca DİĞER tüm sekmeler de anında
// çıkış yapsın; farklı bir hesapla giriş yapılınca diğer sekmeler yeni hesabı
// yansıtsın (yenilenmeden eski hesabı göstermesin).
//
// Neden token değerini dinlemiyoruz: token sessiz "refresh" akışında (AxiosConfig)
// localStorage'a yeniden yazılıyor. Token değişimini dinlersek her refresh diğer
// sekmeleri gereksiz yere reload eder. Bu yüzden YALNIZ açık auth olayları için
// ayrı bir yayın anahtarı kullanırız; refresh bu anahtara dokunmaz.

const KEY = 'auth_broadcast';

/**
 * Açık bir auth olayını diğer sekmelere yayınla.
 * @param {'logout'|'login'} type
 */
export const broadcastAuth = (type) => {
    try {
        // t: her seferinde farklı değer → aynı olay tekrarında da storage event tetiklenir.
        localStorage.setItem(KEY, JSON.stringify({ type, t: Date.now() }));
    } catch (e) {
        // sessizce yoksay (private mode / kota)
    }
};

/**
 * Diğer sekmelerden gelen auth olaylarını dinlemeye başla.
 * storage event yalnız DİĞER sekmelerde tetiklenir (olayı yapan sekmede değil).
 * @returns {() => void} aboneliği iptal eden fonksiyon
 */
export const initCrossTabSession = () => {
    const onStorage = (e) => {
        if (e.key !== KEY || !e.newValue) return;
        let msg;
        try { msg = JSON.parse(e.newValue); } catch (err) { return; }
        if (!msg || !msg.type) return;

        if (msg.type === 'logout') {
            // Başka sekmede çıkış yapıldı → bu sekmeyi de login'e at (zaten login'deyse dokunma).
            if (!/^\/(Login|AdminLogin)(\/|$)/.test(window.location.pathname)) {
                window.location.assign('/Login');
            }
        } else if (msg.type === 'login') {
            // Başka sekmede (muhtemelen farklı hesapla) giriş yapıldı → yeni oturumu yansıtmak için yenile.
            window.location.reload();
        }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
};
